module.exports = __webpack_public_path__ + "img/movements_report.25f2c2b6.png";